<template>
  <footer class="bg-dark footer">
    <!-- back-to-top -->
    <div class="back-to-top gotop" @click="goScrollTop()">TOP</div>
    <div class="container">
      <div class="row">
        <div class="col-md-8 col-sm-12">
          <p> {{site.title}} </p>
          <p> 联系地址：{{site.contact_address}} </p>
          <p> {{site.copyright}} </p>
          <p> <a class="footer-a" href="https://hbca.miit.gov.cn/">{{site.icp}}</a> </p>
        </div>
        <div class="col-md-4 col-sm-12 d-none d-md-block">
          <p style="text-align: right;"><img class="footer-qrcode" :src="site.qrcodeUrl"></p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
  const axios = require('axios');

  export default {
    name: 'my-header',
    data() {
      return {
        site: [{}]
      }
    },
    mounted () {
      let that = this;
      // 获取站点信息
      axios.get(that.global.apiUrl + '/web/site/queryAll')
        .then(function (response) {
          if (response.data.success && response.data.data.length > 0) {
            that.site = response.data.data[0]
            // that.site.logoUrl = that.global.apiUrl + '/file/getImgStream?idFile=' + that.site.logo
            that.site.qrcodeUrl = that.global.apiUrl + '/file/getImgStream?idFile=' + that.site.qrcode
          }
        });

    },
    watch: {

    },
    methods:{
      goScrollTop() {
        document.documentElement.scrollTop = 0;
      }
    }
  };
</script>

<style>
  .footer {
    height: 210px;
    padding: 30px 0;
    color: #FFFFFF;
    font-size: 14px;
  }
  .footer-a {
    font-size: 14px;
    color: #FFFFFF;
  }
  .footer-a:hover {
    color: #FFFFFF;
  }
  .footer-qrcode {
    width: 140px;
    height: 140px;
  }
  .gotop {
    position: fixed;
    bottom: 40px;
    right: 20px;
    z-index: 9999999;
    color: #fff;
    text-align: center;
    font-size: 14px;
    transition: none;
    background-color: #000;
    width: 50px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/views/footer/footer.vue